(function () {
  'use strict';


  angular
    .module('rosterScoringReport', [
      'ui.router'
    ]);
}());
